<template>
	<!-- 产品类型历史记录 -->
	<el-dialog :visible.sync="dialogVisible" :title="title" width="80%" :close-on-click-modal="false">
		<div class="main_bg">
			<div class="item_info border_Warningcolor">
				<el-descriptions class="margin-top" title="调拨单信息" :column="3" border>
					<el-descriptions-item label="调拨单号">{{ editForm.code }}</el-descriptions-item>
					<el-descriptions-item label="调出门店"><span style="width: 140px; display: inline-block">{{ editForm.outStoreName }}</span></el-descriptions-item>
					<el-descriptions-item label="调入门店">{{ editForm.inStoreName }}</el-descriptions-item>
					<el-descriptions-item label="类型/商品数量">{{ editForm.productTypeQty }} / {{ editForm.productQty }}</el-descriptions-item>
					<el-descriptions-item label="经办人">{{ editForm.creator }}</el-descriptions-item>
					<el-descriptions-item label="经办时间">{{ editForm.createTime }}</el-descriptions-item>
					<el-descriptions-item label="是否确认">{{ editForm.isConfirm ? "是" : "否" }}</el-descriptions-item>
					<el-descriptions-item label="确认人">{{ editForm.confirmUserName }}</el-descriptions-item>
					<el-descriptions-item label="确认时间">{{ editForm.confirmDate }}</el-descriptions-item>
					<el-descriptions-item label="是否接收">{{ editForm.isReceive ? "是" : "否" }}</el-descriptions-item>
					<el-descriptions-item label="接收人">{{ editForm.receiveUserName }}</el-descriptions-item>
					<el-descriptions-item label="接收时间">{{ editForm.receiveTime }}</el-descriptions-item>
					<el-descriptions-item label="备注" span="3">{{ editForm.remark }}</el-descriptions-item>
				</el-descriptions>
			</div>
			<div class="item_info border_Danger">
				<div class="item_title">调拨商品明细</div>
				<div class="btnDiv"></div>
				<el-table class="lcsj-data-table" :cell-class-name="$moneyCellClass" v-loading="loading" :data="listData" border stripe :highlight-selection-row="true" empty-text="暂无数据" :header-cell-style="{ textAlign: 'center' }">
					<el-table-column prop="rowNumber" label="序号" width="60" align="center"></el-table-column>
					<el-table-column prop="productInfo.typeName" label="类型名称" width="100" align="center"></el-table-column>
					<el-table-column prop="productInfo.productName" label="商品名称" width="200" align="center"></el-table-column>
					<el-table-column prop="productInfo.specification" label="规格" min-width="150" align="center"></el-table-column>
					<el-table-column prop="price" label="价格(元)" width="90" align="center"></el-table-column>
					<el-table-column prop="quantity" label="数量" width="90" align="center"></el-table-column>
					<el-table-column v-if="canSeeCost" prop="costMoney" label="成本(元)" width="90" align="center"></el-table-column>
					<el-table-column prop="money" label="金额(元)" width="90" align="center">
						<template #default="scope">
							{{ scope.row.price * scope.row.quantity }}
						</template>
					</el-table-column>
					<el-table-column prop="productInfo.unit" label="单位" width="80" align="center"></el-table-column>
				</el-table>
			</div>
		</div>
		<template #footer>
			<span>
				<el-button icon="el-icon-close" size="small" @click="dialogVisible = false">关闭</el-button>
				<el-button v-if="btnPermission.confirm && !editForm.isConfirm" size="small" type="primary" icon="el-icon-check" @click="handleConfirmClick()">确认</el-button>
				<el-button v-if="btnPermission.receive && !editForm.isReceive && editForm.isConfirm" size="small" icon="el-icon-check" type="primary" @click="handleReceiveClick()">接收</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script>
import costPermission from "@/utils/costPermission.js";
import { ConfirmProductTransferRecord, ReceiveProductTransferRecord, GetProductTransferRecordDetail } from "@/api/productApi.js";
export default {
	mixins: [costPermission],
	data() {
		return {
			title: "",
			loading: false, //是显示加载
			dialogVisible: false, //控制编辑页面显示与隐藏
			listData: [],
			formInline: {
				keyId: ""
			},
			editForm: {},
			btnPermission: {
				confirm: false,
				receive: false
			}

		};
	},
	created() {
		this.checkBtnPermission();

	},
	components: {},
	methods: {
		// 检查按钮权限
		checkBtnPermission() {
			this.btnPermission.confirm = this.$checkBtnPermission("/transfer/main", "confirm");
			this.btnPermission.receive = this.$checkBtnPermission("/transfer/main", "receive");
		},
		//显示编辑界面
		showTransferDetailDialog(row) {
			this.formInline.keyId = row.keyId;
			this.title = "【" + row.code + "】" + "调拨单详情";
			this.getDetail();
			this.dialogVisible = true;
		},
		getDetail() {
			this.loading = true;
			GetProductTransferRecordDetail(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.editForm = res.data;
						this.listData = res.data.dtls;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 关闭编辑、增加弹出框
		handleClose() {
			this.dialogVisible = false;
			this.listData = [];
			this.editForm = {};
		},
		// 确认调拨
		handleConfirmClick() {
			if (this.editForm.isConfirm) {
				this.$message({
					type: "info",
					message: "该调拨单已确认，无需重复确认！"
				});
				return;
			}
			this.$confirm("确定确认该调拨记录吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				ConfirmProductTransferRecord(this.formInline)
					.then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "确认成功！"
							});
							this.getDetail();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.$message.error("确认失败，请稍后再试！");
					});
			});
		},
		// 接收调拨
		handleReceiveClick() {
			if (this.editForm.isReceive) {
				this.$message({
					type: "info",
					message: "该调拨单已接收，无需重复接收！"
				});
				return;
			}

			this.$confirm("确定接收该调拨记录吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				ReceiveProductTransferRecord(this.formInline)
					.then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "接收成功！"
							});
							this.getDetail();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.$message.error("接收失败，请稍后再试！");
					});
			});
		}
	}
};
</script>
<style scoped lang="scss">
.main_bg {
	padding: 10px;
	margin-top: -15px;
}

.item_info {
	border-left: 5px solid var(--app-primary-hover);
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border-bottom: 2px solid var(--app-border);
}

.border_Warningcolor {
	border-left: 5px solid var(--app-warning);
}

.border_Green {
	border-left: 5px solid var(--app-success);
}

.border_Danger {
	border-left: 5px solid var(--app-danger);
}

.item_title {
	display: flex;
	width: 100%;
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 10px;
	justify-content: space-between;

	.title {
		display: inline-block;
		unicode-bidi: isolate;
	}

	.btnDiv {
		display: block;
		unicode-bidi: isolate;
		word-break: break-all;
	}

	.btnDivItem {
		display: inline-block;
	}

	.text-red {
		display: block;
		background-color: var(--app-danger);
	}
}
</style>
